// src/config.js

// API endpoint - change this to your Cloudflare Worker URL
export const API_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:8787' 
  : 'https://api.namecamper.com';